import React from 'react';
import { Form, Input } from 'antd';
import './CustomerTextInput.scss';

function CustomerTextInput({
  className,
  name,
  label,
  errorMessage,
  rules = [],
  disabled = false,
  type = 'text',
}) {
  return (
    <Form.Item rules={rules} className={`customer-input ${className}`} name={name} label={label} help={errorMessage} validateStatus={errorMessage && 'error'}>
      <Input
        disabled={disabled}
        type={type}
      />
    </Form.Item>
  );
}

export default CustomerTextInput;
